import { c as _c } from "react/compiler-runtime";
import { RemoveFromProjectDialog } from "@components/project/remove-from-project-dialog";
import { useCompanyId } from "@context-providers/company-id-provider";
import { DeleteIcon, MenuItem, Tooltip } from "@flat-ui";
import { REMOVE_MEMBER_THROUGH_TEAM_MESSAGE } from "@src/constants/team-constants";
import { REMOVE_RESOURCE_OWNER_MESSAGE } from "@src/constants/project-constants";
import { useState } from "react";
/**
 * Menu item that removes a member from a single project. Disabled with an
 * explanatory tooltip when the member's access comes through a team or when the
 * member is the project's resource owner.
 */
export function RemoveMemberMenuItem(t0) {
  const $ = _c(19);
  const {
    project,
    member,
    isAssignedThroughTeam,
    isResourceOwner,
    onRemoved,
    closeMenu
  } = t0;
  const companyId = useCompanyId();
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  let t1;
  if ($[0] !== closeMenu) {
    t1 = function closeDialog() {
      setIsDialogOpen(false);
      closeMenu();
    };
    $[0] = closeMenu;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const closeDialog = t1;
  const isRemovalDisabled = isAssignedThroughTeam || isResourceOwner;
  const disabledReason = isAssignedThroughTeam ? REMOVE_MEMBER_THROUGH_TEAM_MESSAGE : REMOVE_RESOURCE_OWNER_MESSAGE;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => setIsDialogOpen(true);
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== isRemovalDisabled) {
    t3 = <MenuItem label="Remove member" Icon={DeleteIcon} disabled={isRemovalDisabled} onClick={t2} />;
    $[3] = isRemovalDisabled;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const menuItem = t3;
  let t4;
  if ($[5] !== disabledReason || $[6] !== isRemovalDisabled || $[7] !== menuItem) {
    t4 = isRemovalDisabled ? <Tooltip component="div" title={disabledReason}>{menuItem}</Tooltip> : menuItem;
    $[5] = disabledReason;
    $[6] = isRemovalDisabled;
    $[7] = menuItem;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== closeDialog || $[10] !== companyId || $[11] !== isDialogOpen || $[12] !== member || $[13] !== onRemoved || $[14] !== project) {
    t5 = isDialogOpen && <RemoveFromProjectDialog companyId={companyId} project={project} member={member} location="member-group-project-menu" onClose={closeDialog} onRemoved={onRemoved} />;
    $[9] = closeDialog;
    $[10] = companyId;
    $[11] = isDialogOpen;
    $[12] = member;
    $[13] = onRemoved;
    $[14] = project;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== t4 || $[17] !== t5) {
    t6 = <>{t4}{t5}</>;
    $[16] = t4;
    $[17] = t5;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  return t6;
}